<template>
    <div
        class="sidebar__content"
        v-if="currentActivity">
        <h3 class="h2">{{ product.title }}</h3>

        <ul class="sidebar__specs">
            <li>
                <div class="label-text">
                    datum
                </div>

                <div>{{ currentActivity.date | dateformat("D MMMM YYYY") }}</div>
            </li>
            <li>
                <div class="label-text">
                    tijd
                </div>

                <div>{{ currentActivity.start_time | dateformat("HH:mm") }} - {{ currentActivity.end_time | dateformat("HH:mm") }} uur</div>
            </li>
            <li>
                <div class="label-text">
                    Locatie activiteit
                </div>

                <div class="sidebar__logo-text">
                    <div>
                        {{ product.location.name }} - {{ product.location.street }} {{ product.location.house_number }},
                        {{ product.location.postal_code }} {{ product.location.city }}
                    </div>

                    <figure>
                        <img
                            v-if="product.location.images.thumbnail"
                            :src="product.location.images.thumbnail"
                            :alt="product.location.name">
                    </figure>
                </div>
            </li>
            <li v-if="currentActivity.available_places > 0">
                <div class="label-text">
                    Beschikbaarheid
                </div>

                <div>Nog {{ currentActivity.available_places }} plekken beschikbaar!</div>
            </li>
            <!-- <li v-if="currentActivity.register_before">
                <div class="label-text">
                    Uiterste inschrijfdatum
                </div>

                <p>{{ currentActivity.register_before | dateformat("D MMMM YYYY") }}</p>
            </li> -->
        </ul>
    </div>
</template>

<script>
import _find from 'lodash.find';

export default {
    props: {
        product: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            selectedDate: 0,
        }
    },
    computed: {
        currentActivity() {
            if(this.product.events.length === 0) {
                this.productNotFound();
                return null;
            } else {
                const resolvedProduct = _find(this.product.events, {id: parseInt(this.$route.query.id)});

                if(!resolvedProduct) {
                    this.productNotFound();
                    return null;
                }

                return _find(this.product.events, {id: parseInt(this.$route.query.id)});
            }
        },
    },
    methods: {
        productNotFound() {
            this.$router.push({
                name: 'activity_detail',
                params: this.$route.params,
                query: this.$route.query,
            });
        }
    }
};
</script>
